<div
  class="container-fluid pt-2 pb-0 px-0 max-height data-monitor-measure"
  :id="$options.name + dataMonitorFunctionSettings.getTypeCaller()"
>
  <div class="row mx-0 max-height">
    <div class="col-12 px-0 max-height data-monitor-measure__container" id="data-monitor-measure_tab">
      <div style="display: flex;">
        <b-tabs v-show="!noSignalItems" v-model="selectedTab" style="width: 100%;">
          <b-tab
            v-for="(tab, index) in tabs"
            :key="index"
            @click="currentTab = index"
            :active="currentTab === index"
            :title="$t(tab.name)"
          >
          </b-tab>
        </b-tabs>
        <!-- 最大化時のグラフ設定ボタンなどの遷移先となる空のDOM -->
        <div class="tab-right-button">
          <div :id="graphSettingsDestinationId" />
        </div>
      </div>

      <div v-show="!noSignalItems" class='tab-content' :class="{'no-scroll': currentTab !== tabSplit}">
        <div class="tab-contents-area">
          <div v-show="enableZoomControlSelect" class="graph-top-actions">
            <div class="zoom-control-pill">
              <b-form-select
                :model-value="zoomDisplayValue"
                :options="zoomDisplayOptions || []"
                size="sm"
                class="zoom-control-select"
                @update:model-value="handleZoomDisplayValueChange"
              >
                <template #first>
                  <b-form-select-option
                    v-if="zoomDisplayValue && !(zoomDisplayOptions || []).includes(zoomDisplayValue)"
                    :value="zoomDisplayValue"
                    disabled
                    hidden
                  >
                    {{ zoomDisplayValue }}
                  </b-form-select-option>
                </template>
              </b-form-select>
            </div>
          </div>

          <div v-show="currentTab === tabList || isShowListWithGraph" key="tab1" class="list-area" :class="currentTab === tabList ? '' : 'list-with-graph'">
            <measure-list
              v-if="!isOnlyCsvExport"
              :selectedFunctionList="selectedFunctionList"
              :executionList="executionList"
              :funcValues="funcValues"
              :measurementList="measurementList"
              :measurementUuid="measurementUuid"
              :windowSize="windowSize"
              :highlightItems="highlightItems"
              :conversionList="conversionList"
              :specifiedSystemId="specifiedSystemId"
              :selectedGraphCheckList="selectedGraphCheckList"
              :dataMonitorFunctionSettings="dataMonitorFunctionSettings"
              :showModal="showModal"
              :currentTab="currentTab"
              :isHev="isHev"
              :atInfo="atInfo"
              :isActiveTestDriving="isActiveTestDriving"
              :isShow="currentTab === tabList || isShowListWithGraph"
              :splitGraphItemColors="getSplitGraphItemColors()"
              :unionGraphItemColors="getUnionGraphItemColors()"
              :isCursorDisplay="isCursorDisplay()"
              @change-check-value="changeCheckValue"
              @on-click-row="onClickRow"
            />
          </div>

          <div v-if="currentTab !== tabList" class="div-arrow-radius" @click="onClickShowListWithGraph">
            <svg v-if="isShowListWithGraph" viewBox="0 0 24 24" class="arrow-icon">
              <path d="M14 7l-5 5 5 5V7z" class="icon-color" />
              <path d="M24 0v24H0V0h24z" fill="none" />
            </svg>
            <svg v-else viewBox="0 0 24 24" class="arrow-icon">
              <path d="M10 17l5-5-5-5v10z" class="icon-color" />
              <path d="M0 24V0h24v24H0z" fill="none" />
            </svg>
          </div>

          <transition name="fade">
            <div key="tab2" class="graph-area__container" v-show="currentTab === tabSplit" :class="currentTab === tabSplit ? 'showed-graph' : ''">
              <!-- ヘルプは無効化でなく非表示にする -->
              <icon-popover v-if="!btnDisabled.help" :iconKey="POPOVER_ICON_KEY.HELP"
                :contentsKey="CONTENTS_KEY.DATA_MONITOR_GRAPH_HELP" :positionClass="POSITION_CLASS.OVER_GRAPH_RIGHT_TOP" />

              <div v-for="(k, i) in selectedFunctionKeys()" :key="i" class="graph-area" :style="getGraphAreaStyle(i)">
                <div v-show="isSelectedFunctionKey(i)" class="graph-area">
                  <graph-element
                    :id="splitGraphId(i + 1)"
                    :xaxes-info="setXAxesInfo()"
                    :yaxes-info="setYAxesInfo(tabSplit, i)"
                    :index="i" />
                </div>
              </div>
            </div>
          </transition>

          <transition name="fade">
            <div key="tab3" class="graph-area__container" v-show="currentTab === tabUnion" :class="currentTab === tabUnion ? 'showed-graph' : ''">
              <!-- ヘルプは無効化でなく非表示にする -->
              <icon-popover v-if="!btnDisabled.help" :iconKey="POPOVER_ICON_KEY.HELP"
                :contentsKey="CONTENTS_KEY.DATA_MONITOR_GRAPH_HELP" :positionClass="POSITION_CLASS.OVER_GRAPH_RIGHT_TOP" />

              <div v-show="showUnionGraph()" class="graph-area">
                <graph-element
                  :id="unionGraphId()"
                  :xaxes-info="setXAxesInfo()"
                  :yaxes-info="setYAxesInfo(tabUnion)" />
              </div>
            </div>
          </transition>
        </div>
      </div>

      <div v-show="currentTab === tabList && dataMonitorFunctionSettings.isTimeLine && !noSignalItems" class="seek-bars mb-1 pt-1">
        <div class="seek-bar-container">
          <div class="seek-bar">
            <time-line :id="listTimeLineId()"
              ref = "timeLineSeekBar"
              :start-time = "startTimeVal()"
              :end-time = "endTimeVal()"
              no-range = true
              disable = true />
          </div>
          <span class="time-line-indicator">{{currentTimeStr}}</span>
          <no-text-svg-button
            :iconKey="BTN_ICON_KEY.MARKER"
            v-show="dataMonitorFunctionSettings.isPersist"
            ref="mark_button_0"
            :disabled="btnDisabled.marker"
            :class="BUTTON_TYPE.MARKER"
            variant="outline-info"
            @click="openMarkModalForNew(tabList)"
            :title="$t('individual.label_data_monitor_hint_add_marker_action')"
          />
        </div>
      </div>

      <div v-show="currentTab === tabSplit && dataMonitorFunctionSettings.isTimeLine && !noSignalItems" class="seek-bars mb-1 pt-1">
        <div class="seek-bar-container">
          <div class="seek-bar">
            <time-line :id="splitTimeLineId()" ref="splitGraphTimeLineSeekBar" :start-time="startTimeVal()" :end-time="endTimeVal()"
              range-only=true disable=true />
          </div>
          <span class="time-line-indicator">{{currentTimeStr}}</span>
          <no-text-svg-button
            :iconKey="BTN_ICON_KEY.MARKER"
            v-show="dataMonitorFunctionSettings.isPersist"
            ref="mark_button_1"
            :disabled="btnDisabled.marker"
            :class="BUTTON_TYPE.MARKER"
            variant="outline-info"
            @click="openMarkModalForNew(tabSplit)"
            :title="$t('individual.label_data_monitor_hint_add_marker_action')"
          />
        </div>
      </div>

      <div v-show="currentTab === tabUnion && dataMonitorFunctionSettings.isTimeLine && !noSignalItems" class="seek-bars mb-1 pt-1">
        <div class="seek-bar-container">
          <div class="seek-bar">
            <time-line :id="unionTimeLineId()" ref="unionGraphTimeLineSeekBar" :start-time="startTimeVal()" :end-time="endTimeVal()"
              range-only=true disable=true />
          </div>
          <span class="time-line-indicator">{{currentTimeStr}}</span>
          <no-text-svg-button
            :iconKey="BTN_ICON_KEY.MARKER"
            v-show="dataMonitorFunctionSettings.isPersist"
            ref="mark_button_2"
            :disabled="btnDisabled.marker"
            :class="BUTTON_TYPE.MARKER"
            variant="outline-info"
            @click="openMarkModalForNew(currentTab)"
            :title="$t('individual.label_data_monitor_hint_add_marker_action')"
          />
        </div>
      </div>

      <div class="bottom-controls" v-if="isShowOperationControls">
        <!-- 再生画面と計測専用モードでは非表示かつスペースを確保するため、v-showでなくvisibilityを変更 -->
        <!-- #3494 specifiedSystemId 有無でボタンを分けていたが、こちらの「戻る」ボタンに UI を統一 -->
        <div class="left-side-btn" :class="{ invisible: !dataMonitorFunctionSettings.isTimeLine }">
          <b-button
            variant="outline-primary"
            :disabled="btnDisabled.seekBtns"
            @click="backSelect"
          >
            {{ $t("message.common_button_back") }}
          </b-button>
        </div>
        <div class="center-side-btn">
          <!-- タブごとにインスタンスが分かれてるので、3つボタンを作っている -->
          <div class="skip-btns" v-show="currentTab === 0 && dataMonitorFunctionSettings.isTimeLine && !noSignalItems">
            <no-text-svg-button
              :iconKey="BTN_ICON_KEY.SKIP_BACK_LONG"
              :id="`${componentName()}-dm-backLong-0`"
              :disabled="btnDisabled.seekBtns"
              variant="outline-info"
              :class="BUTTON_TYPE.BOTTOM_SMALL"
              :title="$t('individual.label_data_monitor_hint_skip_back_long_action')"
            />
            <no-text-svg-button
              :iconKey="BTN_ICON_KEY.SKIP_BACK_SHORT"
              :id="`${componentName()}-dm-backShort-0`"
              :disabled="btnDisabled.seekBtns"
              variant="outline-info"
              :class="BUTTON_TYPE.BOTTOM_SMALL"
              :title="$t('individual.label_data_monitor_hint_skip_back_short_action')"
            />

            <no-text-svg-button
              :iconKey="BTN_ICON_KEY.SKIP_FORWARD_SHORT"
              :id="`${componentName()}-dm-forwardShort-0`"
              :disabled="btnDisabled.seekBtns"
              variant="outline-info"
              :class="BUTTON_TYPE.BOTTOM_SMALL"
              :title="$t('individual.label_data_monitor_hint_skip_forward_short_action')"
            />
            <no-text-svg-button
              :iconKey="BTN_ICON_KEY.SKIP_FORWARD_LONG"
              :id="`${componentName()}-dm-forwardLong-0`"
              :disabled="btnDisabled.seekBtns"
              variant="outline-info"
              :class="BUTTON_TYPE.BOTTOM_SMALL"
              :title="$t('individual.label_data_monitor_hint_skip_forward_long_action')"
            />
          </div>

          <div class="skip-btns" v-show="currentTab === 1 && dataMonitorFunctionSettings.isTimeLine && !noSignalItems">
            <no-text-svg-button
              :iconKey="BTN_ICON_KEY.SKIP_BACK_LONG"
              :id="`${componentName()}-dm-backLong-1`"
              :disabled="btnDisabled.seekBtns"
              variant="outline-info"
              :class="BUTTON_TYPE.BOTTOM_SMALL"
              :title="$t('individual.label_data_monitor_hint_skip_back_long_action')"
            />
            <no-text-svg-button
              :iconKey="BTN_ICON_KEY.SKIP_BACK_SHORT"
              :id="`${componentName()}-dm-backShort-1`"
              :disabled="btnDisabled.seekBtns"
              variant="outline-info"
              :class="BUTTON_TYPE.BOTTOM_SMALL"
              :title="$t('individual.label_data_monitor_hint_skip_back_short_action')"
            />

            <no-text-svg-button
              :iconKey="BTN_ICON_KEY.SKIP_FORWARD_SHORT"
              :id="`${componentName()}-dm-forwardShort-1`"
              :disabled="btnDisabled.seekBtns"
              variant="outline-info"
              :class="BUTTON_TYPE.BOTTOM_SMALL"
              :title="$t('individual.label_data_monitor_hint_skip_forward_short_action')"
            />
            <no-text-svg-button
              :iconKey="BTN_ICON_KEY.SKIP_FORWARD_LONG"
              :id="`${componentName()}-dm-forwardLong-1`"
              :disabled="btnDisabled.seekBtns"
              variant="outline-info"
              :class="BUTTON_TYPE.BOTTOM_SMALL"
              :title="$t('individual.label_data_monitor_hint_skip_forward_long_action')"
            />
          </div>

          <div class="skip-btns" v-show="currentTab === 2 && dataMonitorFunctionSettings.isTimeLine && !noSignalItems">
            <no-text-svg-button
              :iconKey="BTN_ICON_KEY.SKIP_BACK_LONG"
              :id="`${componentName()}-dm-backLong-2`"
              :disabled="btnDisabled.seekBtns"
              variant="outline-info"
              :class="BUTTON_TYPE.BOTTOM_SMALL"
              :title="$t('individual.label_data_monitor_hint_skip_back_long_action')"
            />
            <no-text-svg-button
              :iconKey="BTN_ICON_KEY.SKIP_BACK_SHORT"
              :id="`${componentName()}-dm-backShort-2`"
              :disabled="btnDisabled.seekBtns"
              variant="outline-info"
              :class="BUTTON_TYPE.BOTTOM_SMALL"
              :title="$t('individual.label_data_monitor_hint_skip_back_short_action')"
            />

            <no-text-svg-button
              :iconKey="BTN_ICON_KEY.SKIP_FORWARD_SHORT"
              :id="`${componentName()}-dm-forwardShort-2`"
              :disabled="btnDisabled.seekBtns"
              variant="outline-info"
              :class="BUTTON_TYPE.BOTTOM_SMALL"
              :title="$t('individual.label_data_monitor_hint_skip_forward_short_action')"
            />
            <no-text-svg-button
              :iconKey="BTN_ICON_KEY.SKIP_FORWARD_LONG"
              :id="`${componentName()}-dm-forwardLong-2`"
              :disabled="btnDisabled.seekBtns"
              variant="outline-info"
              :class="BUTTON_TYPE.BOTTOM_SMALL"
              :title="$t('individual.label_data_monitor_hint_skip_forward_long_action')"
            />
          </div>
        </div>

        <div v-show="!noSignalItems && Object.keys(conversionList).length && dataMonitorFunctionSettings.isTimeLine" class="center-cursor-btns">
          <!-- タイムラインのないWS22はカーソルボタンを表示しない -->
          <no-text-svg-button
            :iconKey="BTN_ICON_KEY.CURSOR_A"
            :disabled="btnDisabled.cursorBtns || currentTab === tabList"
            :class="BUTTON_TYPE.BOTTOM_SMALL"
            variant="outline-info"
            @click="setCursor(CURSOR.A)"
            :title="$t('individual.label_button_add_cursor').replace('$TYPE$', CURSOR.A)"
          />
          <no-text-svg-button
            :iconKey="BTN_ICON_KEY.CURSOR_B"
            :disabled="btnDisabled.cursorBtns || currentTab === tabList"
            :class="BUTTON_TYPE.BOTTOM_SMALL"
            variant="outline-info"
            @click="setCursor(CURSOR.B)"
            :title="$t('individual.label_button_add_cursor').replace('$TYPE$', CURSOR.B)"
          />
        </div>

        <div v-show="!noSignalItems && (dataMonitorFunctionSettings.isStartButton || dataMonitorFunctionSettings.isStopButton)" class="right-side-btn">
          <b-button
            v-show="dataMonitorFunctionSettings.isStopButton"
            v-if="inExecution"
            variant="primary"
            :disabled="btnDisabled.execute"
            @click="stopMonitor"
          >
            {{ $t('individual.button_data_monitor_stop') }}
          </b-button>
          <b-button
            v-show="dataMonitorFunctionSettings.isStartButton"
            v-else
            variant="primary"
            :disabled="btnDisabled.execute"
            @click="startMonitor"
          >
            {{ $t('individual.button_data_monitor_measure') }}
          </b-button>
        </div>
      </div>

      <div class="bottom-controls" v-else>
        <!-- 下部タイムライン操作ボタンを表示しないWS45/125などもカーソル設定ボタンを表示する -->
        <div v-show="Object.keys(conversionList).length" class="left-cursor-btns">
          <no-text-svg-button
            :iconKey="BTN_ICON_KEY.CURSOR_A"
            :disabled="btnDisabled.cursorBtns || currentTab === tabList"
            :class="BUTTON_TYPE.BOTTOM_SMALL"
            variant="outline-info"
            @click="setCursor(CURSOR.A)"
            :title="$t('individual.label_button_add_cursor').replace('$TYPE$', CURSOR.A)"
          />
          <no-text-svg-button
            :iconKey="BTN_ICON_KEY.CURSOR_B"
            :disabled="btnDisabled.cursorBtns || currentTab === tabList"
            :class="BUTTON_TYPE.BOTTOM_SMALL"
            variant="outline-info"
            @click="setCursor(CURSOR.B)"
            :title="$t('individual.label_button_add_cursor').replace('$TYPE$', CURSOR.B)"
          />
        </div>
      </div>

      <processing-view :processing="processing"></processing-view>
    </div>
  </div>

  <b-modal v-model="modalMark" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t("individual.label_data_monitor_marker") }}
      </div>
    </template>
    <!-- 再生画面の場合はデータの置き場所によってマーカーAPIの向き先を変え、endpointが空の場合はDMATのAPIを使用する。計測画面はendpointを常に空を渡してDMATのAPIを使用する -->
    <mark-page
      v-show="modalMark"
      ref="modal_mark"
      :measurementUuid="measurementUuid"
      :apiToken="apiToken"
      :elapsedTime="elapsedTime"
      :markerUuid="markerUuid"
      :endpoint="dataMonitorFunctionSettings.isPlay() ? endpoint : ''"
      :userId="userId"
      :ws45MarkerInfo="ws45MarkerInfo"
      :elapsedTimeForTestMode="elapsedTimeForTestMode"
      :commentForTestMode="commentForTestMode"
      :tagForTestMode="tagForTestMode"
      :loadMark="loadMark"
      :modalMark="modalMark"
      :isTestMode="isTestMode"
      @set-mark-modal-loading="setMarkModalProcessing"
    />
    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="outline-primary" @click="modalMark = false" class="ml-2 mr-2" :disabled="markModalProcessing">
          {{ $t("message.common_button_cancel") }}
        </b-button>
        <b-button v-if="showDeleteButton" size="sm" variant="outline-primary" @click="markDelete" class="ml-2 mr-2" :disabled="markModalProcessing">
          {{ $t("individual.button_data_monitor_delete") }}
        </b-button>
        <b-button size="sm" variant="primary" @click="markUpdate" class="ml-2 mr-2" :disabled="markModalProcessing">
          {{ $t("message.common_button_save") }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <b-modal v-model="modalConfigGraph" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ getDisplayPartsConfigureGraph().TITLE }}
      </div>
    </template>

    <config-graph
      v-if="modalConfigGraph"
      ref="config_graph"
      :selectedGraphList="selectedGraphList"
      :conversionList="conversionList"
      :displayPartsInfo="getDisplayPartsConfigureGraph()"
      :xRange="xRange"
      :yRange="yRange"
      :lineSetting="lineSetting"
      :dataMonitorFunctionSettings="dataMonitorFunctionSettings"
      @handle-config-graph-complete="handleConfigGraphComplete"
    />

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="outline-primary" @click="modalConfigGraph = false" class="ml-2 mr-2">
          {{ configGraphButtonCapt(0) }}
        </b-button>
        <b-button size="sm" variant="primary" @click="handleOkConfigGraphModal" class="ml-2 mr-2">
          {{ configGraphButtonCapt(1) }}
        </b-button>
      </div>
    </template>
  </b-modal>
</div>